<section class="campanhas-page extrato">
  @if (plano(); as planoAtual) {
    <app-plano-cabecalho [plano]="planoAtual" (voltar)="voltarParaLista()" />
  }

  @if (rascunho(); as config) {
    <div class="extrato__titulo-linha">
      <div class="extrato__titulo-grupo">
        <h2 class="extrato__titulo">Extrato de desligamento</h2>
        <p class="extrato__descricao">
          Defina as regras para geração do extrato, conforme o regulamento do plano.
        </p>
      </div>
      @if (ultimaAlteracao(); as alteracao) {
        <p class="extrato__auditoria" data-testid="extrato-ultima-alteracao">
          Última alteração por <strong>{{ alteracao.usuario }}</strong> em {{ dataHora(alteracao.dataHora) }}
        </p>
      }
    </div>

    <!-- Mesmo visual das abas do plano. -->
    <div class="extrato__abas" role="tablist" aria-label="Parametrização do extrato de desligamento" data-testid="extrato-abas">
      @for (aba of abas; track aba.id) {
        <button
          type="button"
          role="tab"
          class="extrato__aba"
          [class.extrato__aba--ativa]="abaAtiva() === aba.id"
          [id]="'extrato-aba-' + aba.id"
          [attr.aria-selected]="abaAtiva() === aba.id"
          [attr.aria-controls]="'extrato-painel-' + aba.id"
          [attr.data-testid]="'extrato-aba-' + aba.id"
          (click)="selecionarAba(aba.id)"
        >
          {{ aba.rotulo }}
        </button>
      }
    </div>

    <!-- Criada na primeira visita e mantida ao trocar de aba (não perde alterações). -->
    @if (notificacoesAberta()) {
      <div
        id="extrato-painel-notificacoes"
        role="tabpanel"
        aria-labelledby="extrato-aba-notificacoes"
        [hidden]="abaAtiva() !== 'notificacoes'"
        data-testid="extrato-painel-notificacoes"
      >
        <app-calendarizacao-notificacoes
          [planoId]="planoId"
          [nomePlano]="plano()?.nome ?? ''"
          (salvo)="ultimaAlteracao.set($event)"
        />
      </div>
    }

    <form
      id="extrato-painel-elegibilidade"
      role="tabpanel"
      aria-labelledby="extrato-aba-elegibilidade"
      [hidden]="abaAtiva() !== 'elegibilidade'"
      class="extrato__form"
      novalidate
      data-testid="extrato-form"
      (submit)="$event.preventDefault(); salvar()"
    >
      <!--
        US01: critérios gerais. Fora da tela por enquanto: a situação cadastral passou para cada
        instituto e o card ficou sem critérios.
      <vivest-card variant="default" full-width role="group" aria-labelledby="extrato-criterios-titulo">
        <div class="extrato-bloco">
          <div class="extrato-bloco__cabecalho">
            <h3 id="extrato-criterios-titulo" class="extrato-bloco__titulo">Critérios gerais</h3>
            <p class="extrato-bloco__descricao">
              Quem não atender a estes critérios não gera extrato, e os institutos dele não são avaliados.
            </p>
          </div>

          <div class="extrato-criterios"></div>
        </div>
      </vivest-card>
      -->

      <!-- US02 a US04: institutos, regras e mensagens -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="extrato-institutos-titulo">
        <div class="extrato-bloco">
          <div class="extrato-bloco__cabecalho">
            <h3 id="extrato-institutos-titulo" class="extrato-bloco__titulo">Institutos no extrato</h3>
            <p class="extrato-bloco__descricao">
              Institutos desabilitados não aparecem no extrato. Cada regra só é atendida quando o participante
              cumpre todas as condições dela.
            </p>
          </div>

          <ul class="extrato-institutos">
            @for (instituto of config.institutos; track instituto.idInstParam) {
              <li
                class="extrato-instituto"
                [class.extrato-instituto--desabilitado]="!instituto.habilitado"
                [attr.data-testid]="'extrato-instituto-' + (instituto.tipo ?? instituto.idInstParam)"
              >
                <div class="extrato-instituto__cabecalho">
                  <div class="extrato-instituto__identificacao">
                    <h4 class="extrato-instituto__nome" [id]="'extrato-instituto-nome-' + instituto.idInstParam">
                      {{ nome(instituto) }}
                    </h4>
                    @if (descricao(instituto); as texto) {
                      <p class="extrato-instituto__descricao">{{ texto }}</p>
                    }
                  </div>
                  <label class="extrato-instituto__habilitar">
                    <vivest-switch
                      [checked]="instituto.habilitado"
                      (change)="habilitar(instituto, $any($event.target).checked)"
                      [attr.aria-labelledby]="'extrato-instituto-nome-' + instituto.idInstParam + ' extrato-instituto-estado-' + instituto.idInstParam"
                      data-testid="extrato-instituto-habilitado"
                    ></vivest-switch>
                    <span [id]="'extrato-instituto-estado-' + instituto.idInstParam" class="extrato-instituto__estado">
                      {{ instituto.habilitado ? 'Habilitado' : 'Desabilitado' }}
                    </span>
                  </label>
                </div>

                @if (instituto.habilitado) {
                  <!-- Mesmo card da regra, com editar e excluir. As situações se leem como uma frase com
                       "ou" (basta uma), como as condições da regra com "e". -->
                  <div
                    role="group"
                    class="extrato-regra extrato-situacoes-instituto"
                    [class.extrato-situacoes-instituto--erro]="mostrarErros() && institutosSemSituacao().has(instituto.idInstParam)"
                    [attr.aria-labelledby]="'extrato-situacoes-rotulo-' + instituto.idInstParam"
                    [attr.aria-describedby]="
                      'extrato-situacoes-dica-' + instituto.idInstParam +
                      (mostrarErros() && institutosSemSituacao().has(instituto.idInstParam) ? ' extrato-situacoes-erro-' + instituto.idInstParam : '')
                    "
                    data-testid="extrato-situacoes"
                  >
                    <div class="extrato-regra__conteudo">
                      <p class="extrato-regra__condicoes" data-testid="extrato-situacoes-lista">
                        <span [id]="'extrato-situacoes-rotulo-' + instituto.idInstParam" class="extrato-regra__numero">
                          Situação cadastral<span class="extrato__obrigatorio" aria-hidden="true">*</span>
                        </span>
                        @for (situacao of instituto.situacoesCadastrais; track situacao; let ultima = $last) {
                          <span class="extrato-regra__condicao" [attr.data-testid]="'extrato-situacao-' + situacao">
                            {{ rotuloSituacao(situacao) }}
                          </span>
                          @if (!ultima) {
                            <span class="extrato-regra__e"> ou </span>
                          }
                        } @empty {
                          <span class="extrato-situacoes-instituto__vazio" data-testid="extrato-situacoes-vazio">
                            Nenhuma situação adicionada.
                          </span>
                        }
                      </p>
                      <p [id]="'extrato-situacoes-dica-' + instituto.idInstParam" class="extrato-regra__mensagem">
                        <vivest-icon name="users" source="feather" aria-hidden="true"></vivest-icon>
                        <span>O participante precisa estar em uma destas situações.</span>
                      </p>
                      @if (mostrarErros() && institutosSemSituacao().has(instituto.idInstParam)) {
                        <p
                          [id]="'extrato-situacoes-erro-' + instituto.idInstParam"
                          class="extrato__erro"
                          role="alert"
                          data-testid="extrato-situacoes-erro"
                        >
                          Adicione ao menos uma situação cadastral.
                        </p>
                      }
                    </div>
                    @if (instituto.situacoesCadastrais.length) {
                      <div class="extrato-regra__acoes">
                        <vivest-icon-button
                          variant="outline"
                          size="sm"
                          icon="edit-2"
                          icon-source="feather"
                          [attr.aria-label]="'Editar situação cadastral de ' + nomeCurto(instituto)"
                          data-testid="extrato-situacoes-editar"
                          (click)="editarSituacoes(instituto)"
                        ></vivest-icon-button>
                        <vivest-icon-button
                          class="extrato-regra__excluir"
                          variant="outline"
                          size="sm"
                          icon="trash-2"
                          icon-source="feather"
                          [attr.aria-label]="'Excluir situação cadastral de ' + nomeCurto(instituto)"
                          data-testid="extrato-situacoes-excluir"
                          (click)="excluirSituacoes(instituto)"
                        ></vivest-icon-button>
                      </div>
                    }
                  </div>

                  <div class="extrato-instituto__regras">
                    @if (instituto.regras.length) {
                      <ol class="extrato-regras" [attr.aria-label]="'Regras de ' + nomeCurto(instituto)">
                        @for (regra of instituto.regras; track regra.id; let i = $index) {
                          <li class="extrato-regra" [attr.data-testid]="'extrato-regra-' + regra.id">
                            <div class="extrato-regra__conteudo">
                              <!-- As condições se somam: o "e" entre elas diz que todas precisam ser atendidas. -->
                              <p class="extrato-regra__condicoes" data-testid="extrato-regra-condicoes">
                                @if (instituto.regras.length > 1) {
                                  <span class="extrato-regra__numero">Regra {{ i + 1 }}</span>
                                }
                                @for (item of regra.condicoes; track item.idCondicao; let ultima = $last) {
                                  <span class="extrato-regra__condicao">{{ condicao(item) }}</span>
                                  @if (!ultima) {
                                    <span class="extrato-regra__e"> e </span>
                                  }
                                }
                              </p>
                              @if (regra.mensagem) {
                                <p class="extrato-regra__mensagem" data-testid="extrato-regra-mensagem">
                                  <vivest-icon name="message-square" source="feather" aria-hidden="true"></vivest-icon>
                                  <span><span class="visually-hidden">Mensagem de não elegibilidade: </span>{{ regra.mensagem }}</span>
                                </p>
                              } @else {
                                <p class="extrato-regra__mensagem extrato-regra__mensagem--vazia">
                                  Sem mensagem de não elegibilidade.
                                </p>
                              }
                            </div>
                            <div class="extrato-regra__acoes">
                              <vivest-icon-button
                                variant="outline"
                                size="sm"
                                icon="edit-2"
                                icon-source="feather"
                                [attr.aria-label]="'Editar regra ' + (i + 1) + ' de ' + nomeCurto(instituto)"
                                data-testid="extrato-regra-editar"
                                (click)="editarRegra(instituto, regra)"
                              ></vivest-icon-button>
                              <vivest-icon-button
                                class="extrato-regra__excluir"
                                variant="outline"
                                size="sm"
                                icon="trash-2"
                                icon-source="feather"
                                [attr.aria-label]="'Excluir regra ' + (i + 1) + ' de ' + nomeCurto(instituto)"
                                data-testid="extrato-regra-excluir"
                                (click)="excluirRegra(instituto, regra)"
                              ></vivest-icon-button>
                            </div>
                          </li>
                        }
                      </ol>
                    } @else {
                      <p class="extrato-instituto__sem-regra" data-testid="extrato-instituto-sem-regra">
                        Sem regras: o instituto aparece para todo participante que gera o extrato.
                      </p>
                    }
                    <div class="extrato-instituto__acoes">
                      <vivest-button
                        variant="outline"
                        size="sm"
                        data-testid="extrato-situacoes-adicionar"
                        (click)="adicionarSituacao(instituto)"
                      >
                        <vivest-icon slot="icon-left" name="plus" source="feather"></vivest-icon>
                        Adicionar Situação Cadastral
                      </vivest-button>
                      <vivest-button
                        variant="outline"
                        size="sm"
                        data-testid="extrato-regra-adicionar"
                        (click)="adicionarRegra(instituto)"
                      >
                        <vivest-icon slot="icon-left" name="plus" source="feather"></vivest-icon>
                        Adicionar regra
                      </vivest-button>
                    </div>
                  </div>
                } @else if (instituto.regras.length) {
                  <p class="extrato-instituto__sem-regra" data-testid="extrato-instituto-regras-guardadas">
                    As regras deste instituto ficam guardadas e voltam a valer quando ele for habilitado.
                  </p>
                }
              </li>
            }
          </ul>
        </div>
      </vivest-card>

      <!-- US05: adesão automática -->
      <vivest-card variant="default" full-width role="group" aria-labelledby="extrato-adesao-titulo">
        <div class="extrato-bloco">
          <div class="extrato-bloco__cabecalho">
            <h3 id="extrato-adesao-titulo" class="extrato-bloco__titulo">Adesão automática</h3>
            <p class="extrato-bloco__descricao">
              Enquadra o participante num instituto quando o prazo de opção vence sem que ele escolha.
            </p>
          </div>

          <div class="extrato-adesao">
            <vivest-checkbox
              label-variant="multi-line"
              name="adesao-automatica"
              [checked]="config.adesaoAutomatica.habilitada"
              (change)="marcarAdesaoAutomatica($any($event.target).checked)"
              [attr.aria-describedby]="config.adesaoAutomatica.habilitada ? 'extrato-adesao-fluxo' : 'extrato-adesao-prazo'"
              data-testid="extrato-adesao-automatica"
            >
              Permitir adesão automática
            </vivest-checkbox>

            @if (config.adesaoAutomatica.habilitada) {
              <!-- A regra lida como frase: condição (prazo vencido sem escolha) → resultado (instituto padrão). -->
              <div id="extrato-adesao-fluxo" class="extrato-adesao__regra" data-testid="extrato-adesao-fluxo">
                <div
                  id="extrato-adesao-prazo"
                  class="extrato-adesao__condicao"
                  [class.extrato-adesao__condicao--alerta]="!prazoOpcaoDias()"
                  data-testid="extrato-adesao-prazo"
                >
                  @if (prazoOpcaoDias(); as prazo) {
                    <span class="extrato-adesao__frase extrato-adesao__antes">Sem escolha de instituto em </span>
                    <span class="extrato-adesao__prazo" data-testid="extrato-adesao-janela">{{ prazo }} dias </span>
                    <span class="extrato-adesao__frase extrato-adesao__depois">após receber o extrato</span>
                  } @else {
                    <span class="extrato-adesao__frase extrato-adesao__antes">Prazo de opção</span>
                    <span class="extrato-adesao__prazo">não definido</span>
                    <span class="extrato-adesao__frase extrato-adesao__depois">a adesão automática não acontece</span>
                  }
                </div>

                <span class="extrato-adesao__seta" aria-hidden="true">
                  <vivest-icon name="arrow-right" source="feather"></vivest-icon>
                </span>

                <div class="extrato-adesao__resultado">
                  <vivest-select
                    class="extrato-adesao__instituto"
                    label="Instituto padrão"
                    name="instituto-padrao"
                    required
                    placeholder="Escolha o instituto"
                    [options]="opcoesInstitutoPadrao()"
                    [value]="config.adesaoAutomatica.institutoPadrao?.toString() ?? ''"
                    [attr.status]="mostrarErros() && erroInstitutoPadrao() ? 'error' : 'default'"
                    [attr.error-message]="mostrarErros() ? erroInstitutoPadrao() : ''"
                    (change)="escolherInstitutoPadrao($any($event.target).value)"
                    data-testid="extrato-instituto-padrao"
                  ></vivest-select>
                  <span class="extrato-adesao__frase extrato-adesao__dica">O participante entra neste instituto.</span>
                </div>

                <p class="extrato-adesao__nota" role="note" data-testid="extrato-adesao-nota">
                  <vivest-icon name="info" source="feather" aria-hidden="true"></vivest-icon>
                  <span>
                    {{ prazoOpcaoDias() ? 'O prazo de opção é definido em' : 'Defina o prazo de opção em' }}
                    <button type="button" class="extrato__link" (click)="voltar()">Institutos do plano</button>.
                  </span>
                </p>
              </div>
            } @else {
              <p id="extrato-adesao-prazo" class="extrato-adesao__resumo" data-testid="extrato-adesao-prazo">
                @if (prazoOpcaoDias(); as prazo) {
                  Desativada: quem não escolher um instituto em {{ prazo }} dias continua sem instituto.
                  O prazo é definido em
                  <button type="button" class="extrato__link" (click)="voltar()">Institutos do plano</button>.
                } @else {
                  Desativada. O plano também não tem prazo de opção; defina-o em
                  <button type="button" class="extrato__link" (click)="voltar()">Institutos do plano</button>.
                }
              </p>
            }
          </div>
        </div>
      </vivest-card>

      <footer class="extrato__rodape">
        <vivest-button
          variant="outline"
          size="md"
          [disabled]="!temAlteracoes()"
          data-testid="extrato-descartar"
          (click)="descartar()"
        >
          Descartar alterações
        </vivest-button>
        <vivest-button
          variant="primary"
          size="md"
          [disabled]="!temAlteracoes() || !valido()"
          data-testid="extrato-salvar"
          (click)="salvar()"
        >
          <vivest-icon slot="icon-left" name="save" source="feather"></vivest-icon>
          {{ salvando() ? 'Salvando…' : 'Salvar parâmetros' }}
        </vivest-button>
      </footer>
    </form>
  }
</section>

@if (selecionandoSituacoes() !== null) {
  <app-situacoes-cadastrais-modal
    [opcoes]="situacoes()"
    [jaIncluidas]="situacoesDoModal()"
    [modo]="selecionandoSituacoes()!.modo"
    editavel
    descricao="O participante precisa estar em uma destas situações."
    (adicionar)="adicionarSituacoes($event)"
    (fechar)="selecionandoSituacoes.set(null)"
  />
}

@if (regraEmEdicao(); as edicao) {
  <app-regra-elegibilidade-modal
    [instituto]="institutoEmEdicao()"
    [regra]="edicao.regra"
    [condicoes]="condicoes()"
    (salvar)="salvarRegra($event)"
    (fechar)="fecharRegra()"
  />
}

<!-- Confirmação antes de salvar (vivest-modal do design system). -->
<vivest-modal
  heading="Salvar parâmetros"
  description="As novas regras passam a valer nas próximas gerações do extrato de desligamento. Confirma?"
  [open]="confirmandoSalvar()"
  [hasIcon]="false"
  dismissible=""
  (vivest-close)="cancelarSalvar()"
  data-testid="extrato-confirmar"
>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="extrato-confirmar-voltar" (click)="cancelarSalvar()">
    Voltar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="extrato-confirmar-salvar" (click)="confirmarSalvar()">
    Salvar
  </vivest-button>
</vivest-modal>
